// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"747":"vendor.swr","894":"vendor.antv"}[chunkId] + "." + {"747":"ed1301d24d4c41ce499e","894":"6b7d56e6e6cc0ef54819"}[chunkId] + ".js";
};